import './_styles.scss';
import React from "react";
import { Item } from 'components';

export default ({ caption, data=[] }) => (
  <section className='Section-Items-Small'>
    <div className="Section-Wrapper">

      <div className="Section-Caption">
        {caption}
      </div>

      { data.map((a,i) =>
          <Item
            id={a.handle}
            title={a.title}
            brand={a.vendor}
            key={i.toString()}
            image={a.images[0]}
            category={a.category}
            price={a.pricing.price}
          />
        )
      }

    </div>
  </section>
);
